import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { routeNames } from "../../consts/routesNames";
import { useAuth, usePermissions } from "../../auth/hooks/usePermissions";

function RequirePermission({ permission, anyOf, allOf, fallbackPath, children }) {
  const { isAuthenticated } = useAuth();
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to={routeNames.LOGIN} replace />;
  }

  let isAllowed = true;

  if (permission) {
    isAllowed = hasPermission(permission);
  } else if (Array.isArray(anyOf) && anyOf.length > 0) {
    isAllowed = hasAnyPermission(anyOf);
  } else if (Array.isArray(allOf) && allOf.length > 0) {
    isAllowed = hasAllPermissions(allOf);
  }

  if (!isAllowed) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children ?? <Outlet />;
}

RequirePermission.propTypes = {
  permission: PropTypes.string,
  anyOf: PropTypes.arrayOf(PropTypes.string),
  allOf: PropTypes.arrayOf(PropTypes.string),
  fallbackPath: PropTypes.string,
  children: PropTypes.node,
};

RequirePermission.defaultProps = {
  permission: "",
  anyOf: undefined,
  allOf: undefined,
  fallbackPath: routeNames.HOME,
  children: null,
};

export default RequirePermission;
